
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"currentColor","viewBox":"0 0 20 22"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.4 21.536h19.2V9.752H.4v11.784zm4.776-10.344h9.648a3.504 3.504 0 003.336 3.288v2.352a3.504 3.504 0 00-3.336 3.264H5.176a3.504 3.504 0 00-3.336-3.264V14.48a3.504 3.504 0 003.336-3.288zm-3.336 7.08a2.064 2.064 0 011.896 1.848H1.84v-1.848zm14.4 1.848a2.064 2.064 0 011.92-1.848v1.848h-1.92zm1.92-7.08a2.064 2.064 0 01-1.896-1.848h1.896v1.848zm-14.4-1.848a2.064 2.064 0 01-1.92 1.848v-1.848h1.92z"}}),_c('path',{attrs:{"d":"M10 18.728a3.095 3.095 0 100-6.19 3.095 3.095 0 000 6.19zM10 14a1.656 1.656 0 110 3.311A1.656 1.656 0 0110 14zm.72-5.808V3.224l1.896 1.896 1.032-1.032L10 .464 6.352 4.088 7.384 5.12 9.28 3.224v4.968h1.44z"}})])
          )
        }
      }
    